import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { StoredItemVm } from './stored-item.vm';


export class GetStoredItemsVm extends PageResponseVm<StoredItemVm, string> {
    @IsString()
    nextOffset: string;

    @Type(() => StoredItemVm)
    @ValidateNested({ each: true })
    objects: StoredItemVm[];
}